import { Icon, TooltipHost } from '@fluentui/react';
import React from 'react';
import { useSettingReveal } from '../../hooks/useSettingReveal';

interface IAccordionBoxProps {
    title?: string;
    /** A string renders as "Title: secondary" (the original behavior); a node renders as-is after the
     * title, for callers that want an icon or their own styling in the header. */
    secondaryTitle?: string | React.ReactNode;
    /** Renders the title in bold. Opt-in so existing boxes keep their look. */
    boldTitle?: boolean;
    isExpanded?: boolean;
    onToggle?: (expanded: boolean, key?: string) => void;
    disabled?: boolean;
    itemKey?: string;
    tooltip?: string;
    tooltipIcon?: string;
    headerBackgroundColor?: string;
}

const AccordionBox: React.FC<IAccordionBoxProps> = (props) => {
    // Lets a settings deep link open this box to reach a control inside it.
    const reveal = useSettingReveal(!!props.isExpanded, () => props.onToggle?.(true, props.itemKey));
    return (
        <div
            {...reveal.revealProps}
            className={`accordion-box${props.isExpanded ? ' expanded' : ''}${props.disabled ? ' disabled' : ''}`}
        >
            <div className="accordion-box-header" style={{ backgroundColor: props.headerBackgroundColor }} onClick={() => {
                if (!props.disabled) {
                    props.onToggle?.(!props.isExpanded, props.itemKey);
                }
            }}>
                <div className="accordion-box-title">
                    {props.boldTitle ? <strong>{props.title}</strong> : props.title}
                    {typeof props.secondaryTitle === 'string'
                        ? (props.secondaryTitle ? `: ${props.secondaryTitle}` : '')
                        : props.secondaryTitle}
                    {props.tooltip && props.tooltipIcon && <TooltipHost content={props.tooltip}>
                        <Icon iconName={props.tooltipIcon} style={{ marginLeft: '5px' }} onClick={(e) => e.stopPropagation()} />
                    </TooltipHost>}
                </div>
                <div className="accordion-box-icon">{props.isExpanded ? '−' : '+'}</div>
            </div>
            {props.isExpanded && <div className="accordion-box-content">
                {props.children}
            </div>}
            {/* Collapsed, but a deep link is looking for a setting: render hidden so it can be found
                and this box asked to open. */}
            {reveal.renderCollapsedChildren && <div className="accordion-box-content" style={reveal.hiddenStyle}>
                {props.children}
            </div>}
        </div>
    );
}

export default AccordionBox;